import React, { useState, useEffect, useMemo } from 'react'

import {
    Button,
    Dialog,
    DialogTitle,
    DialogContent,
    DialogActions,
    MenuItem,
    TextField,
    Typography,
    InputAdornment,
    CircularProgress
} from '@material-ui/core'

import { makeStyles } from '@material-ui/core/styles'
import moment from 'moment'

import NumberFormat from 'react-number-format'

import { useSelector, useDispatch } from 'react-redux'
import { showError, createItem } from '../../../actions/misc/misc.actions'

const useStyles = makeStyles((theme) => ({
    title: {
        // marginBottom: 24
        paddingBottom: 0
    },
    dialogActions: {
        justifyContent: 'flex-start',
        padding: 24
    },
    fieldWrapper: {
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'flex-start',
        alignItems: 'flex-start',
        minWidth: '100% !important',
        width: '100% !important',
        marginBottom: 20,
        // '& .MuiFilledInput-root': {
        //     minWidth: '500px !important',
        //     width: '500px !important'
        // },
        // '& .MuiTextField-root': {
        //     minWidth: '500px !important',
        //     width: '500px !important'
        // },
        '& .MuiFormControl-root .MuiInputLabel-shrink': {
			zIndex: 1
		}
    },

	fullWidth: {
		'& .MuiTextField-root': { width: '100%', minWidth: '100%' },
		'& .MuiFormControl-root .MuiInputLabel-shrink': {
			zIndex: 1
		},
		width: '100%'
	},
    charge: {
        display: 'flex',
        flexDirection: 'row',
        justifyContent: 'flex-start',
        alignItems: 'center',
        paddingBottom: 6
    }
}))



const RefundDialog = ({ charges, setIsShown, isShown, retryCharge, chargeError, loading, refundCharge, chargeAmount }) => {
    const classes = useStyles()
    const dispatch = useDispatch()

    const [amount, setAmount] = useState(0)
    const [reason, setReason] = useState('')

    const closeDialog = () => {
        setIsShown(false)
        setAmount(0)
        setReason(0)
    }

    const originalTotal = useMemo(() => {
        if (!charges) return 0

        const tot = charges.reduce((acc, charge) => acc + charge.amount, 0)
        return tot
    }, [charges])

    const total = useMemo(() => {
        if (!originalTotal) return 0

        if (chargeAmount && chargeAmount < originalTotal) return chargeAmount
        return originalTotal
    }, [originalTotal, chargeAmount])

    useEffect(() => {
        if (total) setAmount(total)
        if (isShown) setReason('')
    }, [total, isShown])

    const onlyNumbers = (value) => {
		if (!value || value === '0') return value
		const onlyNums = value.toString().replace(/[^\d]/g, '').replace(/^0+/, '')
		if (onlyNums.length) return onlyNums
		return 0
	}

	const formatNumsToDollars = (value) => {
		if (value !== undefined && value !== null) {
			return `${(value / 100).toFixed(2)}`
		}
		return ''
	}

    const getValue = () => {
        if (amount) {
            return onlyNumbers(amount)
        }
        return 0
    }

    const sendRefund = () => {
        const refundAmount = getValue()
     
        const data = {
            stripe_charge_id: charges?.[0]?.stripe_charge_id,
            amount: refundAmount,
            reason: reason
        }

        refundCharge(data)
    }


    return (
        <Dialog
            open={isShown}
            aria-labelledby="form-dialog-title"
            className={classes.dialog}
            onClose={closeDialog}
            PaperProps={{
                style: {
                    minWidth: '648px',
                    maxWidth: '648px',
                    width: '648px',
                }
            }}>
            <DialogTitle className={classes.title}>REFUND CHARGE</DialogTitle>
            <DialogContent className={classes.fieldWrapper}>
               
                {
                    chargeError && (
                        <Typography variant="body1" style={{ marginBottom: 12, color: '#DC2A2A' }}>
                            ERROR: {chargeError}
                        </Typography>
                    )
                }
                <Typography variant="body1" style={{ marginBottom: 12 }}>
                    Stripe ID: {charges?.[0]?.stripe_charge_id || ''}
                </Typography>

                {
                    chargeAmount && total < originalTotal && (
                        <Typography variant="body1" style={{ marginBottom: 12, style: 'italic' }}>
                            Note: final charge was reduced by account credit/gift card
                        </Typography> )
                }

               <TextField
                    label="Refund Amount"
                    variant="outlined"
                    style={{ width: '40%', marginTop: 16, marginBottom: 16 }}
                    type="numeric"
                    error={onlyNumbers(amount) > total || onlyNumbers(amount) < 100} 
                    onChange={(e) => {
                       setAmount(e.target.value)
                    }}
                    value={formatNumsToDollars(onlyNumbers(amount))}
                    InputProps={{
                        startAdornment: (
                            <InputAdornment className={classes.currencyAdornment} position="start">
                                $
                            </InputAdornment>
                        )
                    }}
                />
                 <TextField
                    label="Reason"
                    variant="outlined"
                    multiline={true}
                    style={{ width: '100%' }}
                    onChange={(e) => {
                       setReason(e.target.value)
                    }}
                    value={reason}
                    
                />

            </DialogContent>
            <DialogActions className={classes.dialogActions}>
                <Button variant="contained" color="secondary" onClick={() => sendRefund()} style={{ height: 50 }} disabled={loading || onlyNumbers(amount) > total || onlyNumbers(amount) < 100}>
                    {loading ?<CircularProgress/> : 'REFUND CHARGE'}
                </Button>
                <Button variant="outlined" color="secondary" onClick={closeDialog} style={{ height: 50 }} disabled={loading}>
                    CANCEL
                </Button>
            </DialogActions>
        </Dialog>
    )
}

export default RefundDialog
